import { t } from 'ttag';

export const EMAIL_ERROR_MESSAGE = t`Помилка, невалідний емейл`;
export const REQUIRED_FIELD_ERROR_MESSAGE = t`Поле обов'язкове`;
export const ERROR_MESSAGE = t`Йой! Щось пішло не так.`;

export const HANDLED_ERRORS_BY_CODES = [
    'invalid_request',
    'invalid_credentials',
];
